import * as React from 'react';
import FullCellButton from './FullCellButton';
const ToDoValueCell = ({ row }) => {
    const { known, onClickValue, parsable, value } = row.original;
    const className = React.useMemo(() => {
        if (known) {
            return parsable ? 'co-parse-ok' : 'co-parse-no-regex';
        }
        return 'co-parse-no-regex';
    }, [known, parsable]);
    const disabled = false;
    return (React.createElement(FullCellButton, { className: className, disabled: disabled, onClick: onClickValue, text: value }));
};
export default ToDoValueCell;
